import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
  useMemo,
} from "react";

interface Context {
  isDemo?: boolean;
  setIsDemo?: Dispatch<SetStateAction<boolean>>;
}

export const DemoContext = createContext<Context>({});

interface DemoProviderProps {
  children: ReactNode;
}

export const DemoProvider = ({ children }: DemoProviderProps) => {
  const [isDemo, setIsDemo] = useState<boolean>(() => {
    return process.env.NEXT_PUBLIC_IS_DEMO === "true";
  });

  const context: Context = useMemo(
    () => ({
      isDemo,
      setIsDemo,
    }),
    [isDemo, setIsDemo]
  );

  return (
    <DemoContext.Provider value={context}>{children}</DemoContext.Provider>
  );
};
